module.exports = __webpack_public_path__ + "static/img/hangpai_02.1a585c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hangpai_02.png
// module id = eAMf
// module chunks = 1